import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { HIDE_ERROR_TOAST } from '../constant/http-context.constant';
import { IAppState } from '../../store/interface/app.state.interface';
import { LOGIN_ROUTE } from '../constant/route.constant';
import { TokenStoreService } from '../services/token-store.service';
import { extractErrorMessage } from '../../shared/utils/http-error.util';
import * as UserActions from '../../store/user/user.actions';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    private readonly messageService = inject(MessageService);
    private readonly router = inject(Router);
    private readonly store = inject(Store<IAppState>);
    private readonly tokenStore = inject(TokenStoreService);

    intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const token = this.tokenStore.read();
        const request = req.clone({
            url: environment.apiHost + environment.basePath + req.url,
            setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
        });

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (!req.context.get(HIDE_ERROR_TOAST)) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: extractErrorMessage(error),
                    });
                }

                if (error.status === 401 && token) {
                    this.tokenStore.clear();
                    this.store.dispatch(UserActions.setLoggedInUser({ user: null }));
                    void this.router.navigateByUrl(LOGIN_ROUTE, { replaceUrl: true });
                }

                return throwError(() => error);
            }),
        );
    }
}
